import React, { useContext } from "react";
import { Empty, List } from "antd";
import { Observer, observer } from "mobx-react-lite";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { toJS } from "mobx";

import { MessageBar, MessageBarType } from "@fluentui/react";
export const ErrorLogs = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  return (
    <Observer>
      {() => (
        <List
          itemLayout="horizontal"
          locale={{
            emptyText: (
              <Empty description={`No upload errors,everything looks great.`} />
            ),
          }}
          dataSource={naocDailyProductionStore.uploadErrors.map((x) => toJS(x))}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                description={
                  <MessageBar
                    messageBarType={
                      item.type === "Error"
                        ? MessageBarType.error
                        : MessageBarType.warning
                    }
                  >
                    {item.message}
                  </MessageBar>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Observer>
  );
});

